export const fieldClass =
  "min-h-[42px] w-full !rounded-lg border border-slate-300 bg-white px-3 py-2 text-[17px] text-slate-900 shadow-[0_1px_2px_rgba(15,23,42,0.04)] outline-none transition placeholder:text-slate-400 hover:border-slate-400 focus:border-teal-600 focus:ring-2 focus:ring-teal-100 disabled:cursor-not-allowed disabled:bg-slate-100";

export function optionLabel(option: any, key?: string) {
  if (option == null) return "";
  return key ? option[key] : option.label ?? option.name ?? String(option);
}

export function optionValue(option: any, key?: string) {
  if (option == null) return "";
  return key ? option[key] : option.value ?? option;
}

export function emitInput(ctx: any, value: any) {
  ctx.emit("update:modelValue", value);
  ctx.emit("input", value);
}
